import type { CSSProperties } from 'react';

export const colors = {
  bone: '#f7f5f2',
  pink: '#ec4899',
  blue: '#d3e9ff',
  blueText: '#12395c',
  mint: '#c7f5e0',
  mintText: '#0f6b45',
  lavender: '#ece3ff',
  lavenderText: '#4a2f80',
  peach: '#ffe4c2',
  peachText: '#8a4b12',
  red: '#ffd2d2',
  redText: '#9c1c1c',
};

function pillButton(bg: string, text: string): CSSProperties {
  return {
    background: bg,
    color: text,
    border: 'none',
    borderRadius: 999,
    padding: '0.45rem 0.9rem',
    fontWeight: 600,
    cursor: 'pointer',
  };
}

export const primaryButtonStyle: CSSProperties = {
  ...pillButton(colors.pink, '#fff'),
  fontWeight: 700,
  padding: '0.5rem 1.1rem',
};

export const mintButtonStyle = pillButton(colors.mint, colors.mintText);
export const lavenderButtonStyle = pillButton(colors.lavender, colors.lavenderText);
export const peachButtonStyle = pillButton(colors.peach, colors.peachText);

export const cardStyle: CSSProperties = {
  background: colors.blue,
  color: colors.blueText,
  border: 'none',
  borderRadius: 14,
};

export const inputStyle: CSSProperties = {
  border: 'none',
  borderRadius: 10,
  padding: '0.5rem 0.7rem',
  fontWeight: 600,
  fontSize: '1rem',
  background: colors.mint,
  color: colors.mintText,
};

export const inputDangerStyle: CSSProperties = {
  ...inputStyle,
  background: colors.red,
  color: colors.redText,
};

export const fieldLabelStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.3rem',
  fontSize: '0.85rem',
  fontWeight: 600,
};

/** Rounded on/off chip used in place of checkboxes and radio groups. */
export function pillToggleStyle(active: boolean): CSSProperties {
  return {
    ...pillButton(active ? colors.pink : colors.lavender, active ? '#fff' : colors.lavenderText),
    fontSize: '0.9rem',
  };
}

// Shared layout for the create/edit forms (dishes, products): rounded pastel
// section cards holding labelled mint inputs.
export const formFieldStyle: CSSProperties = {
  ...inputStyle,
  width: '100%',
  boxSizing: 'border-box',
  padding: '0.6rem 0.85rem',
};
export const formSectionStyle: CSSProperties = {
  borderRadius: 18,
  padding: '1rem',
  background: colors.blue,
  color: colors.blueText,
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
};
export const formSectionTitleStyle: CSSProperties = { fontWeight: 700, fontSize: '0.95rem' };
export const formNumberRowStyle: CSSProperties = { display: 'flex', flexWrap: 'wrap', gap: '0.75rem' };
export const formNumberFieldStyle: CSSProperties = { ...fieldLabelStyle, flex: '1 1 90px', minWidth: 0 };
export const formSubmitStyle: CSSProperties = { ...primaryButtonStyle, padding: '0.7rem 1.1rem', fontSize: '1rem' };
